import { locale } from '@splunk/splunk-utils/config';
import { itemUsageText } from './constants';
import type { ConfirmDeletionModalProps } from './types';

export const formatUsageConjunction = (
    itemUsage: ConfirmDeletionModalProps['itemUsage']
) => {
    const list = itemUsage?.reduce<string[]>((arr, usageInfo) => {
        if (usageInfo.usedCount >= 1) {
            arr.push(itemUsageText(usageInfo));
        }

        return arr;
    }, []);

    return list?.length
        ? new Intl.ListFormat(locale, { type: 'conjunction' }).format(list)
        : null;
};
